import React from "react";
import { message } from "antd";
import { getServiceType } from "@/common/js/api";
import useUpdateEffect from "@/common/utils/hooks/useUpdateEffect";
import { i18nTranslate } from "@didi/i18n-plugin";

let serviceType: { i18nKey: string; } | null;
const ServiceTypeToastComp = (props: any) => {
  useUpdateEffect(() => {
    if (props.visible && serviceType) {
      const { i18nKey } = serviceType;
  
      message.info(
        i18nTranslate('CS_status_zoxI_Nral', {
          service_type: i18nTranslate(i18nKey)
        }),
        5
      );
    }
  }, [props.visible]);

  return null;
};

const getServiceTypeAndToast = async () => {
  if (serviceType === void 0) {
    serviceType = await getServiceType().then(res => {
      if (res.status === 0) {
        return res.data;
      }
      return null;
    });
  }

  return { default: ServiceTypeToastComp };
};

const ServiceTypeToastLazy = React.lazy(() => getServiceTypeAndToast());

export default function ServiceTypeToast(props: any) {
  return (
    <React.Suspense fallback={null}>
      <ServiceTypeToastLazy visible={props.visible} />
    </React.Suspense>
  )
}